import LegalClause from "../components/LegalClause";
import LegalClauseHeader from "../components/LegalClauseHeader";
import {useEffect} from "react";


const PrivacyPolicy = () => {

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'instant'});
    }, []);

    return (
        <div className="privacy-policy-container home-contents">
            <div className="privacy-policy-title">Privacy Policy</div>
            <div className="privacy-policy-heading">PERILL Diagnostics for Teams – Privacy Supplement</div>
            <div className="privacy-policy-description">
                This privacy supplement provides information around the processing conducted for
                the PERILL Diagnostics for Teams by Clutterbuck Coaching and Mentoring
                International (CCMI) - the trading name of Coaching and Mentoring International
                Limited – a company registered in England and Wales (registration number:
                08158710, registered office: Woodlands, Tollgate, Maidenhead, Berks, United
                Kingdom, SL6 4LJ) and also registered with the Data Protection Authority in the UK
                – ICO Registration Number ZA467620.

            </div>
            <div className="privacy-policy-description">
                <div className="privacy-policy-text-container">
                    CCMI runs a number of coaching and mentoring platforms and resources which
                    have an extensive Privacy Policy in place here –
                    <a href={"https://clutterbuck-cmi.com/privacy-policy/"}>https://clutterbuck-cmi.com/privacy-
                        policy/.</a>
                </div>
            </div>
            <div className="privacy-policy-description">
                This Privacy Policy Supplement explains how we handle personal information that
                we collect in the course of performing our functions and activities within the PERILL
                Diagnostics for Teams service.
            </div>
            <LegalClauseHeader text="1. Data Security">
                <LegalClause text="CCMI is committed to protecting the security of all personal data on the PERILL
                Diagnostics for Teams platform and have implemented various technical and
                organisational measures to safeguard it."/>
                <LegalClause text="These include Advanced Encryption
                Standard (AES-256 military grade) for data at rest, and the recommended
                industry standard of TLS 1.2 for all data in transit. We also implement access
                controls and policies to ensure only authorised personnel or systems can access
                the information alongside firewalls, intrusion detection systems, and anti-malware
                software. We follow OWASP recommendations for web application security and
                conduct regular security audits and vulnerability assessments using established
                3rd party services."/>
            </LegalClauseHeader>
            <LegalClauseHeader text="2. Data Collection & Processing:">
                <LegalClause text="We collect and handle different types of information from or through our PERILL
                Diagnostics for Teams (Services):"/>
                <LegalClause text="Information Collected from Account Holders: Where an individual user registers their
                details for an Account (usually a Team Coach, Team Leader, HR professional or
                similar), we collect Personal Data. Personal Data collected includes name and email
                address. For accredited / certified Team Coaches and similar professionals, we may
                also hold details of your professional awards and certificates. We also store other
                data such as a profile picture, organisation name and logo, team name, job role,
                industry, country or language preferences which could be combined to personally
                identify an individual. The legal basis for this processing is consent."/>
                <LegalClause text="In this context, CCMI is considered both the Data Controller and Data Processor as
                defined by the terms of the European Union’s Directive 95/46/EC on data privacy or
                the General Data Protection Regulation (GDPR) (EU) 2016/679."/>
                <LegalClause text="Information Provided by Account Holders: Where an Account Holder (usually a Team
                Coach, Team Leader, HR professional or similar) registers the details of their team
                coach clients, team members, stakeholders or organisation employees (Survey
                Participants), in order to issue out surveys and manage results of the diagnostic
                survey, the Account Holder is collecting Personal Data. Personal Data collected
                includes name, email address. We also store other data such as an organisation
                name and logo, team name, job role, industry, country or language preferences
                which could be combined to personally identify an individual."/>
                <LegalClause text="In this context, the Account Holder is considered the Data Controller under the
                Directive for any data containing personal information provided by the Account
                Holder, whilst CCMI is the Data Processor. The legal basis for this processing is
                consent. The Account Holder has full responsibility for collecting, and managing the
                Personal Data of all Survey Participants within the PERILL Diagnostics for Teams
                service. Each Account Holder is responsible for confirming they have permission to
                add Survey Participants details and for providing notice to them concerning the
                purpose of doing so prior to adding any Survey Participants Personal Data."/>
                <LegalClause text="User-provided Information: When you use the Service, register your details (such
                as subscribing for our newsletter or enquiries about training) or send us enquiries,
                either as an Account Holder or a User you may provide, and we may collect
                Personal Data. Examples of Personal Data include name and email address. The
                legal basis for this processing is consent."/>
                <LegalClause text="'Automatically Collected' Information: When an Account Holder or User uses the
                Service, we may automatically record certain information from their device by using
                various types of technology, including cookies. This 'automatically collected'
                information may include IP address or other device address or ID, web browser
                and/or device type, the web pages or sites visited just before or just after using the
                Service, the pages or other content the User views or interacts with on the Service,
                and the dates and times of the visit, access, or use of the Service. We also use
                these technologies to collect information regarding an interaction with email
                messages, such as whether the User opens, clicks on, or forwards a message. This
                information is gathered from Account Holders and all Survey Participants. The legal basis for this processing is our
                legitimate interests, namely monitoring and improving
                our website and services."/>
                <div className="legal-clause-container">
                    <div className="legal-clause-text-row">
                        Financial transactions relating to our website and services may be handled by our
                        payment services providers, Stripe. We will share transaction data with our payment
                        services providers only to the extent necessary for the purposes of processing your
                        payments, refunding such payments and dealing with complaints and queries
                        relating to such payments and refunds. The legal basis for this processing is our
                        legitimate interests, namely the proper administration of our website and business.
                        You can find information about the payment services providers’ privacy policies and
                        practices at <a href={'https://stripe.com/gb/privacy'}>https://stripe.com/gb/privacy</a>
                    </div>
                </div>
            </LegalClauseHeader>
            <LegalClauseHeader text="3. Use and Disclosure">
                <LegalClause text="We will use Survey Participants responses to create diagnostic reports for the
                Account Holder to improve the effectiveness of teams. Individual participants names
                will only be provided to Account Holders who are trained Team Coaches (or similar
                professionals) and will be withheld from any other Account Holders (such as a Team
                Leader)."/>
                <LegalClause text="Survey Participants are invited to complete some additional questions on the final
                (End-Point) survey – usually conducted after a period of time with the team leader or
                team coach working with the team. The additional questions relate to how effective
                the PERILL platform and performance methodology is - we may publish these
                anonymous ratings. We also ask questions about your Team Coach (if applicable) -
                we provide these ratings and any comments to your coach anonymously."/>
                <LegalClause text="Team Coaches often work in pairs so the PERILL platform has the ability for a Team
                Coach to securely share details with other Team Coaches (Gold Level members
                only). Coaches can share their Teams (individually or all) with either Edit or Read
                only capabilities that can be revoked at any time. The primary Team Coach to hold
                the legal contract with their Client should ensure they are the Account Holder to
                create the Organisation and any subsequent Teams so that they remain the legal
                Data Controller (regardless of which Coach might adjust the Team – editing
                participants, creating surveys etc)."/>
                <LegalClause text="CCMI has no direct relationship with the companies, clients or individuals (Survey
                Participants) whose Personal Data it hosts and processes on behalf of the Account
                Holder. CCMI has a limited view of Account Holder platform usage but by default
                does not have access to any Account Holder client, organisation, team or participant
                survey information other than in an anonymised form. As the Data Processor, we
                may occasionally view or analyse this attributable data to support an Account Holder
                where requested, general fault finding or platform improvement. At no point will we
                use this data for the marketing or advertising of CCMI services."/>
                <LegalClause text="CCMI will use an anonymised version of the diagnostic data in order to publish
                aggregated benchmark analysis, PERILL effectiveness, improve our survey
                diagnostics, general research and other commercial purposes."/>
                <LegalClause text="Where Account Holders give explicit consent, we may occasionally send marketing
                messages from CCMI or on behalf of other related Team Coaching partners. The
                legal basis for this processing is consent. As CCMI is not the data controller for
                Survey Participants personal data, we cannot and will not access or use this data for
                marketing our Services."/>
                <LegalClause text="We do not under any circumstances provide, rent, sell or exchange any personal
                information to any third parties without your consent other than where you would
                reasonably expect us to disclose it or if we are legally required to do so. Personal
                information in connection with our Services will only be made available to
                contractually bound third party subcontractors to facilitate the provision of Services
                by storing or processing such data on behalf of CCMI."/>

                <LegalClause text=""/>
                <LegalClause text=""/>
            </LegalClauseHeader>
            <LegalClauseHeader text="4. Cookies and Tracking Technologies">
                <LegalClause text="We use automatically collected information and other information collected during
                the Services through cookies and similar technologies to: (i) personalise our Service,
                such as remembering a User’s information or login details so that the User will not
                have to re-enter it during a visit or on subsequent visits; (ii) provide customised
                content and information; (iii) monitor and analyse the effectiveness of Service and
                third-party activities; and (iv) monitor site usage metrics such as the number of visits
                and pages viewed."/>
            </LegalClauseHeader>
            <LegalClauseHeader text="">
                <LegalClause text="Cookies for GA:"/>
                <LegalClause text="The following table descrbies each cookie set by GA4 JavaScript tags."/>
            </LegalClauseHeader>
            <div className="cookie-table">
                <table className="styled-cookie-table">
                    <thead>
                    <tr>
                        <th>Cookie name</th>
                        <th>Default expiration time</th>
                        <th>Description</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>_ga</td>
                        <td>2 years</td>
                        <td>
                            <ul>
                                <li>Used to distinguish users.</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>_ga_{'<container-id>'}</td>
                        <td>2 years</td>
                        <td>
                            <ul>
                                <li>Used to persist session state.</li>
                            </ul>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <LegalClauseHeader text="">
                <LegalClause text="Cookies for Hotjar:"/>
                <LegalClause text="The following cookies, local and session storage items apply when the Hotjar
                Tracking Code has been loaded and ensure the Hotjar Tracking Code functions correctly. Mentions of
                site_id refer to the unique ID allocated to an individual site when it is created in Hotjar."/>
            </LegalClauseHeader>
            <div className="cookie-table">
                <div className="cookie-table-title">Relating to the user</div>
                <table className="styled-cookie-table">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Data storage type</th>
                        <th>Description</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>_hjSessionUser_{'{site_id}'}</td>
                        <td>Cookie</td>
                        <td>
                            <ul>
                                <li>Set when a user first lands on a page.</li>
                                <li>Persists the Hotjar User ID which is unique to that site. Hotjar does not track
                                users across different sites.</li>
                                <li>Ensures data from subsequent visits to the same site are attributed to the same
                                    user ID.</li>
                                <li>365 dats duration.</li>
                                <li>JSON data type.</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>_hjHasCachedUserAttributes</td>
                        <td>Cookie</td>
                        <td>
                            <ul>
                                <li>Enables us to know whether the data set in _hjUserAttributes Local Storage item is
                                    up to date or not.</li>
                                <li>Session duration.</li>
                                <li>Boolean true/false data type.</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>_hjUserAttributesHash</td>
                        <td>Cookie</td>
                        <td>
                            <ul>
                                <li>Enables us to know when any User Attribute has changed and needs to be updated.</li>
                                <li>2 minutes duration, extended every 30 seconds.</li>
                                <li>Content hash data type.</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>_hjUserAttributes</td>
                        <td>Local storage item</td>
                        <td>
                            <ul>
                                <li>Stores user attributes sent through the Hotjar Identify API.</li>
                                <li>No explicit expiration.</li>
                                <li>Base64 encoded JSON data type.</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>_hjViewportID</td>
                        <td>Session storage item</td>
                        <td>
                            <ul>
                                <li>Stores user viewport details such as size and dimensions.</li>
                                <li>Session duration.</li>
                                <li>UUID data type.</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>_hjActiveViewportIds</td>
                        <td>Local storage item</td>
                        <td>
                            <ul>
                                <li>Stores user active viewports IDs.</li>
                                <li>Stores an expirationTimestamp that is used to validate active viewports on script
                                    initialization.</li>
                                <li>It is removed when the browser page is closed.</li>
                                <li>JSON data type.</li>
                            </ul>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div className="cookie-table">
                <div className="cookie-table-title">Relating to the session</div>
                <table className="styled-cookie-table">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Data storage type</th>
                        <th>Description</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>_hjSession_{'{site_id}'}</td>
                        <td>Cookie</td>
                        <td>
                            <ul>
                                <li>Holds current session data.</li>
                                <li>Ensures subsequent requests in the session window are attributed to the same session.</li>
                                <li>30 minutes duration, extended on user activity.</li>
                                <li>JSON data type.</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>_hjCookieTest</td>
                        <td>Cookie</td>
                        <td>
                            <ul>
                                <li>Checks to see if the Hotjar Tracking Code can use cookies. If it can, a value
                                    of 1 is set.</li>
                                <li>Deleted almost immediately after it is created.</li>
                                <li>Under 100ms duration, cookie expiration time set to session duration.</li>
                                <li>Boolean true/false data type.</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>_hjLocalStorageTest</td>
                        <td>Cookie</td>
                        <td>
                            <ul>
                                <li>Checks if the Hotjar Tracking Code can use Local Storage. If it can, a value of
                                1 is set.</li>
                                <li>Data stored in _hjLocalStorageTest has no expiration time, but is deleted almost
                                    immediately after it is created.</li>
                                <li>Under 100ms duration.</li>
                                <li>Boolean true/false data type.</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>_hjSessionStorageTest</td>
                        <td>Cookie</td>
                        <td>
                            <ul>
                                <li>Checks if the Hotjar Tracking Code can use Session Storage. If it can, a value of
                                    1 is set.</li>
                                <li>Data stored in _hjSessionStorageTest has no expiration time, but is deleted almost
                                    immediately after it is created.</li>
                                <li>Under 100ms duration.</li>
                                <li>Boolean true/false data type.</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>_hjTLDTest</td>
                        <td>Cookie</td>
                        <td>
                            <ul>
                                <li>We try to store the _hjTLDTest cookie for different URL substring alternatives
                                    until it fails.</li>
                                <li>Enables us to try to determine the most generic cookie path to use, instead of page
                                    hostname.</li>
                                <li>It means that cookies can be shared across subdomains (where applicable).</li>
                                <li>Session duration.</li>
                                <li>Boolean true/false data type.</li>
                            </ul>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <LegalClauseHeader text="">
                <LegalClause text="Cookies for Stripe:"/>
            </LegalClauseHeader>
            <div className="cookie-table">
                <table className="styled-cookie-table">
                    <thead>
                    <tr>
                        <th>Name of cookie</th>
                        <th>Max age in seconds</th>
                        <th>Description</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>_stripe_mid</td>
                        <td>31536000</td>
                        <td>
                            <ul>
                                <li>Provide fraud prevention.</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>_stripe_sid</td>
                        <td>1800</td>
                        <td>
                            <ul>
                                <li>Provide fraud prevention.</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>m</td>
                        <td>63072000</td>
                        <td>
                            <ul>
                                <li>Blocking cookie prior to obtaining user consent.</li>
                            </ul>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <LegalClauseHeader text="5. Access, Correction and Deletion">
                <LegalClause text="We are committed to safeguarding the privacy of our Account Holders and Survey
                Participants of the PERILL Diagnostics for Teams:"/>
                <LegalClause text="Account Holders - If you wish to access, amend or delete any personal information
                we hold about you, please sign into your Online Account to do so. To request that we
                delete any information about you that we have obtained through the use of our
                Services, you may contact us at diagnostics@clutterbuck-cmi.com. Unless personal
                information is required to be retained by us for administrative or legal reasons, we
                will meet such requests at the earliest possible opportunity."/>
                <LegalClause text="Survey Participants - If you wish to amend or delete any personal information we
                hold about you, please contact the Account Holder (as named in your initial survey
                invite email) as CCMI is only the data processor of your data and therefore not
                legally able to edit or delete it. Once the Account Holder has edited or deleted your details,
                the change is immediate unless the personal information is required to be
                retained by us for administrative or legal reasons."/>
            </LegalClauseHeader>
            <LegalClauseHeader text="6. International transfers of your personal data">
                <LegalClause text="The hosting facilities for our Services are situated in London, England. The European
                Commission has made an “adequacy decision” with respect to the data protection
                laws of each of these countries. Transfers to each of these countries will be
                protected by appropriate safeguards, namely the use of standard data protection
                clauses adopted or approved by the European Commission, a copy of which you can
                obtain from Guide to the UK General Data Protection Regulation (UK GDPR)"/>
            </LegalClauseHeader>
            <LegalClauseHeader text="7. Data Retention">
                <LegalClause text="We only retain the personal information for as long as necessary to fulfil the
                purposes for which we have initially collected it, unless otherwise required by law."/>
                <LegalClause text="For Account Holders, we will delete your account after 12 months of inactivity (no
                login or subscription payment -where applicable). This includes your personal
                information as well as any other data in your account including any clients, teams
                and Survey Participants personal information you have uploaded and any
                subsequent diagnostic surveys or reports. Any Companies or Teams you have
                created and then shared with another coach will also be deleted."/>
                <LegalClause text="For Survey Participants, we will retain your account information using the criteria
                below:"/>
                <LegalClause text="If you as an individual are deleted from the team or organisation (immediate deletion
                and no retention of your Personal Information)"/>
                <LegalClause text="If the team or the organisation you are associated with is deleted (immediate deletion
                and no retention of your Personal Information)"/>
                <LegalClause text="If the Account Holders account becomes inactive for 12 months (no login or
                subscription payment -where applicable), we will delete the account including all
                Personal Information of the Account Holder, Survey Participants, companies and
                teams held within it (immediate deletion and no retention of your Personal
                Information)"/>
                <LegalClause text="CCMI will continue to retain and use the now fully anonymised diagnostic survey
                responses in order to provide benchmarking data and improve our survey
                diagnostics."/>
                <LegalClause text=""/>
            </LegalClauseHeader>
            <LegalClauseHeader text="8. Contact">
                <div className="legal-clause-container">
                    <div className="legal-clause-text-row">If you have any concerns or questions regarding our Privacy
                        Policy or how CCMI protects users data, please contact our data protection officer: practices at &thinsp;
                        <a href="mailto:dpo@coachingandmentoringinternational.org">dpo@coachingandmentoringinternational.org</a>
                    </div>
                </div>
            </LegalClauseHeader>
        </div>
    )
}

export default PrivacyPolicy